// Layout.js
import Button from 'components/Button';
import React, { useState, useEffect, useRef } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { logout } from 'slice/userSlice';
import { useDispatch } from 'react-redux';
import { IoPersonCircleSharp } from 'react-icons/io5';
import { MdContacts, MdDashboard, MdOutlineToys, MdCategory } from 'react-icons/md';
import { FaImages } from 'react-icons/fa';
import { RiOrderPlayLine } from 'react-icons/ri';
import { TbUserSquare } from 'react-icons/tb';
import { io } from "socket.io-client";
import { toast } from 'react-toastify';
import logo from '../asserts/img/tomoyokartlogo.png'

const socket = io(process.env.REACT_APP_BACKEND)

const Layout = ({ children }) => {
  const [toggled, setToggle] = useState(false);
  const [openMenu, setOpenMenu] = useState(null);
  const [notifications, setNotifications] = useState([]);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const audioRef = useRef(null);

  const currentUrl = location.pathname;
  const lastSegment = currentUrl.substring(currentUrl.lastIndexOf('/') + 1);
  const isCategorySection = currentUrl.startsWith('/categories') || currentUrl.startsWith('/subcategories');

  // Toggle sidebar menu
  const toggleMenu = (menu) => {
    setOpenMenu(openMenu === menu ? null : menu);
  };

  // Logout handler
  const logoutHandler = async (e) => {
    e.preventDefault();
    try {
      dispatch(logout());
      navigate('/signin');
    } catch (e) {
      console.log(e);
    }
  };

  // Close dropdowns on route change
  useEffect(() => {
    setOpenMenu(null);
  }, [location.pathname]);

  useEffect(() => {
    socket.on("new-payment", (data) => {
      setNotifications((prev) => [...prev, data]); // ✅ proper update

      // Show toast
      toast('New Order Added');

      // Play sound
      if (audioRef.current) {
        audioRef.current.play().catch((error) => {
          console.warn("Autoplay blocked, will play after interaction:", error);
        });
      }
    });

    return () => {
      socket.off("new-payment");
    };
  }, []);


  return (
    <div id="wrapper">
      {/* eslint-disable jsx-a11y/media-has-caption  */}
      <audio
        ref={audioRef}
        src="https://assets.mixkit.co/active_storage/sfx/933/933-preview.mp3"
        preload="auto"
      />

      <ul
        className={toggled ? 'navbar-nav sidebar sidebar-dark toggled' : 'navbar-nav sidebar sidebar-dark accordion'}
        id="accordionSidebar"
      >
        <Link className="text-decoration-none d-flex align-items-center justify-content-center py-3" to="/dashboard">
          <img
            src={logo}
            alt="Tomoyokart Logo"
            style={{ height: "150px", width: "150px", marginRight: "10px" }}
          />

        </Link>


        {/* Dashboard */}
        <li className="nav-item">
          <Link className="nav-link " to="/dashboard">
            <MdDashboard className="mr-1" size={20} />
            <span style={{ fontSize: "16px" }} className="font-weight-bold">Dashboard</span>
          </Link>
        </li>

        {/* Banner */}
        <li className={`nav-item ${lastSegment === 'banner' ? 'active' : ''}`}>
          <Link
            className="nav-link text-dark collapsed"
            href="#"
            onClick={() => toggleMenu('banner')}
            style={{ color: 'black' }} // ensure black text
          >
            <FaImages className="mr-1" size={20} />
            <span style={{ fontSize: "16px" }} className="font-weight-bold">Sliders</span>
          </Link>
          <div className={`collapse ${openMenu === 'banner' ? 'show' : ''}`}>
            <div className="bg-white py-2 collapse-inner rounded">
              <Link className="collapse-item text-dark" to="/banner/add">
                Add Slider
              </Link>
              <Link className="collapse-item text-dark" to="/banner">
                Slider List
              </Link>
            </div>
          </div>
        </li>

        {/* Product */}
        <li className={`nav-item ${lastSegment === 'product' ? 'active' : ''}`}>
          <Link
            className="nav-link text-dark collapsed"
            href="#"
            onClick={() => toggleMenu('product')}
            style={{ color: 'black' }}
          >
            <MdOutlineToys className="mr-1" size={20} />
            <span style={{ fontSize: "16px" }} className="font-weight-bold">Product</span>
          </Link>
          <div className={`collapse ${openMenu === 'product' ? 'show' : ''}`}>
            <div className="bg-white py-2 collapse-inner rounded">
              <Link className="collapse-item text-dark" to="/products/add">
                Add Product
              </Link>
              <Link className="collapse-item text-dark" to="/products">
                Product List
              </Link>
            </div>
          </div>
        </li>

        <li className={`nav-item ${isCategorySection ? 'active' : ''}`}>
          <Link
            className="nav-link text-dark collapsed"
            href="#"
            onClick={() => toggleMenu('categories')}
            style={{ color: 'black' }}
          >
            <MdCategory className="mr-1" size={20} />
            <span style={{ fontSize: "16px" }} className="font-weight-bold">Categories</span>
          </Link>
          <div className={`collapse ${openMenu === 'categories' ? 'show' : ''}`}>
            <div className="bg-white py-2 collapse-inner rounded">
              <Link className="collapse-item text-dark" to="/categories/add">
                Add Category
              </Link>
              <Link className="collapse-item text-dark" to="/categories">
                Category List
              </Link>
              <Link className="collapse-item text-dark" to="/subcategories/add">
                Add Subcategory
              </Link>
              <Link className="collapse-item text-dark" to="/subcategories">
                Subcategory List
              </Link>
            </div>
          </div>
        </li>

        {/* Customer Orders */}
        <li className={`nav-item ${lastSegment === 'customerorder' ? 'active' : ''}`}>
          <Link
            className="nav-link text-dark collapsed"
            href="#"
            onClick={() => toggleMenu('customerorder')}
            style={{ color: 'black' }}
          >
            <RiOrderPlayLine className="mr-1" size={20} />
            <span style={{ fontSize: "16px" }} className="font-weight-bold">Order List {notifications?.length ? <> <span className="badge badge-danger">New</span> </> : ''}</span>
          </Link>
          <div className={`collapse ${openMenu === 'customerorder' ? 'show' : ''}`}>
            <div className="bg-white py-2 collapse-inner rounded">
              <Link className="collapse-item text-dark" to="/customerorder">
                Order List
              </Link>
            </div>
          </div>
        </li>

        {/* Users */}
        <li className={`nav-item ${lastSegment === 'users' ? 'active' : ''}`}>
          <Link
            className="nav-link collapsed text-dark"
            href="#"
            onClick={() => toggleMenu('users')}
            style={{ color: 'black' }}
          >
            <TbUserSquare className="mr-1" size={20} />

            <span style={{ fontSize: "16px" }} className="font-weight-bold">
              Users
            </span>

          </Link>
          <div className={`collapse ${openMenu === 'users' ? 'show' : ''}`}>
            <div className="bg-white py-2 collapse-inner rounded">
              <Link className="collapse-item font-size-16 text-dark" to="/customer">
                User List
              </Link>
            </div>
          </div>
        </li>

        {/* Contact Us */}
        <li className={`nav-item ${lastSegment === 'contactus' ? 'active' : ''}`}>
          <Link
            className="nav-link collapsed text-dark"
            href="#"
            onClick={() => toggleMenu('contactus')}
            style={{ color: 'black' }}
          >
            <MdContacts className="mr-1" size={20} />
            <span style={{ fontSize: "16px" }} className="font-weight-bold">Contact Us</span>
          </Link>
          <div className={`collapse ${openMenu === 'contactus' ? 'show' : ''}`}>
            <div className="bg-white py-2 collapse-inner rounded">
              <Link className="collapse-item text-dark" to="/contactus">
                Contact Us List
              </Link>
            </div>
          </div>
        </li>

        {/* Sidebar toggle */}
        <div className="text-center text-dark d-none d-md-inline mt-5">
          <button
            className="rounded-circle border-0 text-dark"
            id="sidebarToggle"
            onClick={() => setToggle(!toggled)}
          ></button>
        </div>
      </ul>

      {/* Content */}
      <div id="content-wrapper" className="d-flex flex-column">
        <div id="content">
          <nav
            className="navbar navbar-expand navbar-light bg-white topbar static-top"
            style={{ marginBottom: 0, boxShadow: "none", borderBottom: "1px solid #eef1f6" }}
          >
            <button
              id="sidebarToggleTop"
              onClick={() => setToggle(!toggled)}
              className="btn btn-link d-md-none rounded-circle mr-3"
            >
              <i className="fa fa-bars"></i>
            </button>
            <ul className="navbar-nav ml-auto">
              <li className="nav-item dropdown no-arrow">
                <Link
                  className="nav-link dropdown-toggle"
                  href="#"
                  id="userDropdown"
                  role="button"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  <span className="mr-2 d-none d-lg-inline admintext small">Admin</span>
                  <IoPersonCircleSharp size={20} style={{ color: '#a1572f' }} />
                </Link>
                <div className="dropdown-menu dropdown-menu-right shadow animated--grow-in" aria-labelledby="userDropdown">
                  <div className="dropdown-divider"></div>
                  <Button className="dropdown-item" text="Logout" onclickfun={logoutHandler} />
                </div>
              </li>
            </ul>
          </nav>
          {children}
        </div>
      </div>
    </div>
  );
};

export default Layout;
